import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import FormGenerator from "../../core/form-generator";
import { HTTP_METHODS, invokeApi, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { useNavigate, useParams } from "react-router-dom";
import "./index.scss";
import SiFileUpload from "../../core/file-uploader";
import {
  getFileNameFromUrl,
  handleFormValidation,
  splitFileName,
} from "../../utils";
import { toast } from "react-toastify";
import FreeServices from "../ticket-form/free-services";
import PastHistory from "../ticket-form/past-history";
import {
  ADDRESS_FORM,
  descForm,
  getTicketFormRow3,
  getTicketFormRow1,
  isFormValid,
  formatFreeServicesPayload,
  getApplicationDropdown,
  SOIL_CONDITION_DROPDOWN,
  SERVICE_OBJECT,
  complaintCodeForm,
  UNIT_MACHINE_STATUS_DROPDOWN,
  getUnitMachineStatusForm
} from "../ticket-form/helper";
import CustomButtonComponent from "../../core/custom-button";
import AppContext from "../../utils/context";
import { USER_ROLES } from "../../utils/constants";
import moment from "moment";
import SiAutocomplete from "../../core/si-autocomplete";
import SiTextField from "../../core/si-textfield";

const EditForm = ({ ticketForm, details, setEditForm, loadTicketData }) => {
  const [formData, setFormData] = useState({
    attachments: "no",
    actionTakenByOem: "",
  });
  const [errors, setErrors] = useState({});
  const [oemNames, setOemNames] = useState([]);
  const [complaintCodes, setComplaintCodes] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [files, setFiles] = useState([]);
  const [pastHistory, setPastHistory] = useState([]);
  const { userDetails = {} } = useContext(AppContext);
  const [isManualEntry, setIsManualEntry] = useState(false);
  const [selectedSearchEngine, setSelectedSearchEngine] = useState({});
  const [searchEngineOptions, setSearchEngineOptions] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [isCqc, setIsCqc] = useState(false);
  const [isUnderWarranty, setIsUnderWarranty] = useState({
    showText: false,
    value: null,
  });
  let engineTimeout = null;

  useEffect(() => {
    loadData();
  }, []);
  const loadData = () => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_COMPLAINT_CODES}`,
      null
    )
      .then((response) => {
        if (Array.isArray(response.results) && response.results) {
          let codes = response.results.map((r) => {
            return {
              ...r,
              label: `${r.code} - ${r.description || ""}`,
              value: r.id,
            };
          });
          setComplaintCodes(codes);
          setFormData((prevVal) => ({
            ...prevVal,
            natureOfCustomerComplaint: codes.find(
              (ele) => ele.label === ticketForm.natureOfCustomerComplaint
            ),
          }));
        }
      })
      .catch((err) => console.error(err));
  };

  const submitHandler = () => {
    let payload = { ...formData };
    payload.freeServiceDetails = formatFreeServicesPayload(serviceList);
    payload.pastHistory = pastHistory;
    payload.oemEngineLocation = {
      tractorAddress: payload.tractorAddress,
      city: payload.city,
      pinCode: payload.pinCode,
      state: payload.state?.value,
    };
    payload.unitMachineStatus = formData.unitMachineStatus?.value;
    payload.dateOfSale = moment(payload.dateOfSale, "DD-MM-YYYY").toDate();
    payload.customerComplaintDate = moment(
      payload.customerComplaintDate,
      "DD-MM-YYYY"
    ).toDate();
    payload.oemName = formData.oemName?.label;
    payload.natureOfCustomerComplaint =
      formData.natureOfCustomerComplaint?.value;
    payload.customerRegularApplication =
      formData?.customerRegularApplication?.value;
    payload.applicationWhileComplaintObserved =
      formData?.applicationWhileComplaintObserved?.value;
    payload.soilCondition = formData?.soilCondition?.value;
    if (files.length > 0) {
      payload.attachmentUrls = files.map(
        (f) => splitFileName(f.url || "") || f
      );
    }
    delete payload.city;
    delete payload.pinCode;
    delete payload.state;
    delete payload.tractorAddress;
    let url = `${REST_URLS.COMPLAINT}/oem/${details.ticketId}`;
    if (userDetails.role === USER_ROLES.ADMIN) {
      url = `${REST_URLS.COMPLAINT}/${details.ticketId}`;
    }
    if (!payload?.cqc) {
      delete payload?.cqc;
    }
    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}${url}`, payload)
      .then((response) => {
        if (response.message) {
          toast.error(`Failed to update ticket, ${response.message}`);
        } else {
          toast.success(`Ticket Updated Successfully`);
          loadTicketData(ticketForm.ticketId);

          setEditForm(false);
        }
      })
      .catch((err) => console.error(err));
  };
  const checkWarranty = async (payload) => {
    try {
      const response = await plainApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.CHECK_WARRANTY_ADMIN}`,
        payload
      );
      setIsUnderWarranty({ showText: true, value: response?.underWarranty });
      if (!response?.underWarranty) {
        toast.error("Engine is out of warranty");
      }
    } catch (error) {
      console.error("Error fetching engine options:", error);
    }
  };
  const loadEngines = async (inputValue) => {
    try {
      const response = await plainApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.ADMIN_SEARCH_ENGINE_LIST}`,
        { searchTerm: inputValue, ticketId: details?.ticketId }
      );
      setSearchEngineOptions(
        response.map((item) => ({
          label: item,
          value: item,
        }))
      );
    } catch (error) {
      console.error("Error fetching engine options:", error);
    }
  };
  const handleEngineSearch = (newInputValue) => {
    if (newInputValue && !isManualEntry) {
      clearTimeout(engineTimeout);
      engineTimeout = setTimeout(() => loadEngines(newInputValue), 300);
    }
    setHasSearched(true);
  };
  const saveServices = (newService) => {
    setServiceList([...serviceList, newService]);
    setErrors({
      ...errors,
      freeServicesErr: false,
    });
  };

  const callBack = (newFile) => {
    setFiles((prevVal) => [...prevVal, newFile]);
  };

  const onDelete = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };
  const convertedData = (inputData = {}) => {
    const data = Object.keys(inputData).map((key) => {
      const service = inputData[key];

      return {
        name: {
          label: "1st Service",
          value: key,
        },
        date: service?.date?.split("T")[0], // Extract date (YYYY-MM-DD)
        runningHours: service.runningHours?.toString(), // Convert to string
        jobCardNumber: service.jobCardNumber,
      };
    });
    return data;
  };
  const previewFormHandler = () => {
    const firstForm = getTicketFormRow1(oemNames);
    const unitMachineStatusForm = getUnitMachineStatusForm();
    const secondForm = getTicketFormRow3(complaintCodes, userDetails, oemNames, isCqc, formData.unitMachineStatus?.value );
    const descriptionForm = descForm(userDetails,oemNames, formData.unitMachineStatus?.value);
    const isValid = handleFormValidation(
      [...firstForm, ...unitMachineStatusForm, ...ADDRESS_FORM, ...secondForm, ...descriptionForm],
      setErrors,
      formData
    );
    if (isValid) {
      if (serviceList?.length) {
        for (const service of serviceList) {
          const serviceRunningHours = parseInt(service.runningHours);
          if (serviceRunningHours > formData?.hmr) {
            toast.error(
              `${service.name.label} running hours (${serviceRunningHours}) should be less than or equal to HMR (${formData?.hmr})`
            );
            return;
          }
        }
      }
      if (!formData.engineSerialNumber?.trim()) {
        toast.error("Engine Serial Number is required");
        return;
      }
      if (formData?.hmr < 1) {
        toast.error("HMR should be greater than 0");
        return;
      }
      if (formData.hmr > 100 && serviceList?.length < 1) {
        toast.error("Please Add the Service History");
      } else {
        submitHandler();
      }
    } else {
      toast.error("Please correct the form data");
    }

    // if (isValid) {
    //   submitHandler();
    // } else {
    //   toast.error("Please correct the form data");
    // }
  };

  const showManualEntryCheckbox = hasSearched;

  useEffect(() => {
    if (ticketForm) {
      const dropdownList = getApplicationDropdown(userDetails, oemNames);
      setFormData((prevVal) => ({
        ...prevVal,
        ...ticketForm,
        oemName: { label: ticketForm.oemName, value: ticketForm.oemName },
        state: { label: ticketForm.state, value: ticketForm.state },
        unitMachineStatus: UNIT_MACHINE_STATUS_DROPDOWN.find(
            (item) => item.value === ticketForm.unitMachineStatus
          ) || null,
        customerRegularApplication: dropdownList?.find(
          (ele) => ele.value === ticketForm?.customerRegularApplication
        ),
        applicationWhileComplaintObserved: dropdownList?.find(
          (ele) => ele.value === ticketForm?.applicationWhileComplaintObserved
        ),
        soilCondition: SOIL_CONDITION_DROPDOWN?.find(
          (ele) => ele.value === ticketForm?.soilCondition
        ),
      }));
      if (ticketForm?.cqc) {
        setIsCqc(true);
      }
      setSelectedSearchEngine({
        label: ticketForm.engineSerialNumber,
        value: ticketForm.engineSerialNumber,
      });
      setHasSearched(false);
    }

    if (details) {
      setPastHistory(details?.pastHistory);
      const data = convertedData(details.freeServiceDetails);
      setServiceList(data);
      if (details?.attachmentUrls?.length) {
        setFiles(details.attachmentUrls);
      }
    }
  }, [complaintCodes]);
  useEffect(() => {
    if (formData?.engineSerialNumber && formData?.dateOfSale && formData?.hmr) {
      const timeoutId = setTimeout(() => {
        checkWarranty({
          engineSerialNumber: formData?.engineSerialNumber,
          saleDate: moment(formData?.dateOfSale, "DD-MM-YYYY", true),
          hmr: formData?.hmr,
          ticketId: details?.ticketId,
        });
      }, 2000);
      return () => clearTimeout(timeoutId);
    } else {
      setIsUnderWarranty({ showText: false, value: null });
    }
  }, [formData?.engineSerialNumber, formData?.dateOfSale, formData?.hmr]);
  
 useEffect(() => {
     const statusValue =
       typeof formData.unitMachineStatus === "string"
         ? formData.unitMachineStatus
         : formData.unitMachineStatus?.value;
     const isStockStatus =
       statusValue === "Depot Stock" || statusValue === "Dealer Stock";
 
     if (isStockStatus) {
       setFormData((prevVal) => ({
         ...prevVal,
         // dateOfSale: null,
         customerRegularApplication: null,
         soilCondition: null,
       }));
     }
   }, [formData.unitMachineStatus]);

  return (
    <div className="ct-form">
      <div>
        <p className="form-header" style={{ marginTop: "10px" }}>
          Edit Ticket
        </p>
        <FormGenerator
          config={getTicketFormRow1(oemNames)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />
        <p className="form-sub-header">Customer Address</p>
        <FormGenerator
          config={ADDRESS_FORM}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />
        <Grid item md={12} sx={{ mt: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Grid item md={3.8}>
              <p style={{ marginTop: "0px" }}>Engine Serial Number *</p>
              {!isManualEntry ? (
                <SiAutocomplete
                  value={selectedSearchEngine}
                  onChange={(val) => {
                    setSelectedSearchEngine(val);
                    setFormData((prevVal) => ({
                      ...prevVal,
                      engineSerialNumber: val?.value || "",
                    }));
                  }}
                  options={searchEngineOptions}
                  placeholder="Engine Serial Number"
                  onInputChange={(newInputValue) =>
                    handleEngineSearch(newInputValue)
                  }
                />
              ) : (
                <SiTextField
                  placeholder="Enter engine number manually"
                  value={formData.engineSerialNumber}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSelectedSearchEngine({ label: val, value: val });
                    setFormData((prev) => ({
                      ...prev,
                      engineSerialNumber: val,
                    }));
                  }}
                />
              )}
              {formData?.engineSerialNumber && isUnderWarranty?.showText && (
                <Typography
                  color={isUnderWarranty?.value ? "green" : "error"}
                  sx={{ mt: 1 }}
                >
                  {isUnderWarranty?.value
                    ? "Under Warranty"
                    : "Out of warranty"}
                </Typography>
              )}
            </Grid>
            {/* <Grid item md={3.5} sx={{ ml: 2 }}>
              {hasSearched && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isManualEntry}
                      onChange={(e) => {
                        const manual = e.target.checked;
                        setIsManualEntry(manual);
                        setSearchEngineOptions([]);
                        setSelectedSearchEngine("");
                      }}
                      color="primary"
                    />
                  }
                  label="Engine number is wrong, please enter correct engine serial number"
                  style={{
                    marginTop: 8,
                    color: "red",
                  }}
                />
              )}
            </Grid> */}
            <Grid item md={4} sx={{ ml: 3 }}>
              <FormGenerator
                config={getUnitMachineStatusForm()}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
                fieldGridSize={12}
              />
            </Grid>
          </Box>
        </Grid>
        <FormGenerator
          config={getTicketFormRow3(
            complaintCodes,
            userDetails,
            oemNames,
            isCqc,
            formData.unitMachineStatus?.value
          )}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />
        <div className="history-services">
          <FreeServices
            onSave={saveServices}
            serviceList={serviceList}
            onDelete={(newHistory) => setServiceList(newHistory)}
            error={errors.freeServicesErr || false}
          />
          <PastHistory
            onSave={(newHistory) =>
              setPastHistory([...pastHistory, newHistory])
            }
            pastHistory={pastHistory}
            onDelete={(newHistory) => setPastHistory(newHistory)}
          />
        </div>
        <FormGenerator
          config={complaintCodeForm(complaintCodes)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />
        <FormGenerator
          config={descForm(userDetails, oemNames, formData.unitMachineStatus?.value)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          {userDetails.role !== USER_ROLES.ADMIN && (
            <SiFileUpload id={null} callBack={callBack} />
          )}

          <div>
            <CustomButtonComponent
              variant="contained"
              onClick={previewFormHandler}
              size="small"
              sx={{ ml: 2, width: "150px" }}
            >
              Submit
            </CustomButtonComponent>
          </div>
        </div>
      </div>

      {files.map((r, index) => {
        return (
          <div key={r.blobName + index}>
            <span>{r.blobName || getFileNameFromUrl(r, 25)}</span>
            <IconButton onClick={() => onDelete(index)} sx={{ p: 0 }}>
              <CancelOutlinedIcon />
            </IconButton>
          </div>
        );
      })}
    </div>
  );
};

export default EditForm;
